import {
	defaultFetchState,
	fetchRequested,
	fetchFailed,
	fetchSuccess,
	defaultSaveState,
	saveRequested,
	saveFailed,
	saveSuccess,
} from "utils";
import { STAFF_TRAINING_UI_ENABLED } from "utils/navigation-filter";

import * as fromTypes from "../actions/types";

const defaultState = {
	incidents: true,
	inductionMeetings: true,
	safetyMinutes: true,
	staffTraining: false,
	siteInspections: true,
	jsa: true,
	siteSafetyPlans: true,
	workTypes: true,
	equipment: false,
	equipmentUsageRecording: false,
	leave: true,
	tasks: false,
	manualTimesheetEntries: false,
	timesheetTimeEditHistory: false,
	timesheetApprovals: false,
	timerTimesheetEntries: true,
	// Optional list of column keys to include in the default Timesheet CSV export.
	// When null/empty, all columns are exported.
	timesheetCsvColumns: null,
	// Terminology overrides — null means use built-in defaults ("Customer" / "Site").
	customerLabel: null,
	siteLabel: null,
	...defaultFetchState,
	...defaultSaveState,
};

// Transform PascalCase API response to camelCase state properties
const transformApiResponseToState = (apiResponse) => {
	if (!apiResponse) return {};
	
	return {
		incidents: apiResponse.Incidents ?? apiResponse.incidents ?? true,
		inductionMeetings: apiResponse.InductionMeetings ?? apiResponse.inductionMeetings ?? true,
		safetyMinutes: apiResponse.SafetyMinutes ?? apiResponse.safetyMinutes ?? true,
		// Force off while Staff Training UI is hidden (STAFF_TRAINING_UI_ENABLED)
		staffTraining: STAFF_TRAINING_UI_ENABLED
			? (apiResponse.StaffTraining ?? apiResponse.staffTraining ?? false)
			: false,
		siteInspections: apiResponse.SiteInspections ?? apiResponse.siteInspections ?? true,
		jsa: apiResponse.JSA ?? apiResponse.jsa ?? true,
		siteSafetyPlans: apiResponse.SiteSafetyPlans ?? apiResponse.siteSafetyPlans ?? true,
		workTypes: apiResponse.WorkTypes ?? apiResponse.workTypes ?? true,
		equipment: apiResponse.Equipment ?? apiResponse.equipment ?? false, // Equipment defaults to disabled
		equipmentUsageRecording:
			apiResponse.EquipmentUsageRecording ??
			apiResponse.equipmentUsageRecording ??
			false,
		leave: apiResponse.Leave ?? apiResponse.leave ?? true, // Leave defaults to enabled
		tasks: apiResponse.Tasks ?? apiResponse.tasks ?? false, // Tasks defaults to disabled
		manualTimesheetEntries: apiResponse.ManualTimesheetEntries ?? apiResponse.manualTimesheetEntries ?? false, // Manual timesheet entries defaults to disabled
		timesheetTimeEditHistory: apiResponse.TimesheetTimeEditHistory ?? apiResponse.timesheetTimeEditHistory ?? false,
		timesheetApprovals: apiResponse.TimesheetApprovals ?? apiResponse.timesheetApprovals ?? false,
		// Timer entries are always available; we no longer respect a TimerTimesheetEntries flag from the API.
		timerTimesheetEntries: true,
		// Keep the raw column keys array if provided, otherwise leave as null (all columns).
		timesheetCsvColumns:
			apiResponse.TimesheetCsvColumns ??
			apiResponse.timesheetCsvColumns ??
			null,
		// Terminology overrides — null means use the built-in default label.
		customerLabel: apiResponse.CustomerLabel ?? apiResponse.customerLabel ?? null,
		siteLabel: apiResponse.SiteLabel ?? apiResponse.siteLabel ?? null,
	};
};

const featureFlags = (state = defaultState, action) => {
	switch (action.type) {
		case fromTypes.FEATURE_FLAGS_FETCH:
			return fetchRequested(state);
		case fromTypes.FEATURE_FLAGS_FETCH_FAILED:
			return fetchFailed(state, action.payload);
		case fromTypes.FEATURE_FLAGS_FETCH_SUCCESS:
			return {
				...fetchSuccess(state),
				...transformApiResponseToState(action.payload),
			};
		case fromTypes.FEATURE_FLAGS_SAVE:
			return saveRequested(state);
		case fromTypes.FEATURE_FLAGS_SAVE_FAILED:
			return saveFailed(state, action.payload);
		case fromTypes.FEATURE_FLAGS_SAVE_SUCCESS:
			return saveSuccess(state);
		default:
			return state;
	}
};

export default featureFlags;

